<template>
	<div class="innerBox">
		<div class="row">
		  <div class="col-md-6" :class="mobile ? 'order-1 mb-3' : 'order-2 text-right'">
			<button type="button" class="btn btn-sm btn-primary" @click="$router.push('/work-order-listing')">< Kembali</button>
		  </div>
		  <div class="col-md-6" :class="mobile ? 'order-2' : 'order-1'">
			<h2 class="mb-4">Detail Warna</h2>
		  </div>
		</div>

		<div class="row" v-if="woDetail">
			<div class="col-md-4 align-middle" :class="{'mb-4' : mobile}">
				<img :src="env.baseImage + '/' + woDetail.image[0]" style="max-height:350px"  class="w-100" v-if="woDetail.image[0]" alt="No Image">
				<h4 v-else class="text-center">No Image Available</h4>
			</div>
			<div class="col-md-8">
				<div class="row">
					<div class="col-md-6 offset-md-2">
						<table class="wo-stats">
							<tr>
								<th>Work Order ID:</th>
								<td>{{ woDetail.work_order_id }}</td>
							</tr>
							<tr>
								<th>Merk & Tipe:</th>
								<td>{{ woDetail.tipe }}</td>
							</tr>
							<tr>
								<th>Warna Mobil:</th>
								<td>{{ woDetail.car_color }}</td>
							</tr>
							<tr>
								<th>No Rangka:</th>
								<td>{{ woDetail.nomor_rangka }}</td>
							</tr>
							<tr>
								<th>No Polisi:</th>
								<td>{{ woDetail.nomor_polisi }}</td>
							</tr>
						</table>
					</div>
				</div>
			</div>
		</div>

		<div class="mt-5">
			<div class="row">
				<div class="col" style="display: flex; flex-direction: row; justify-content: space-between;">
					<h3>Isi Komposisi Warna Baru</h3>
					<button class="btn btn-primary" type="button" @click="addNewComposition"><i class="fas fa-plus"></i></button>
				</div>
			</div>
			<table class="table">
				<thead>
					<tr>
						<th>Kode</th>
						<th>Nama</th>
						<th>Berat Terpakai</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					
						<paintList 
							v-for="(color, index) in newComposition"
							:key="'color' + index"
							:color="color"
							:paintList="paintList"
							:buttonsShow="buttonsShow"
							@newComposition="newComposition.splice(index , 1)"
						/>
						<!-- <td>
							<input type="text" class="form-control" v-model="color.paint_code" placeholder="Tulis kode warna">
						</td>
						<td>
							<input type="text" class="form-control" v-model="color.name" placeholder="Tulis nama warna">
						</td>
						<td>
							<input type="text" class="form-control" v-model="color.used_weight" placeholder="Ketik berat(gram) terpakai">
						</td>
						<td class="text-center">
							<button type="button" class="btn btn-outline-danger" @click="newComposition.splice(index, 1)" :disabled="!buttonsShow">
								<i class="fas fa-times"></i>
							</button>
						</td> -->
					
					
				</tbody>
			</table>
			<div class="row" v-if="buttonsShow">
				<div class="col text-center">
					<button class="btn btn-outline-danger" @click="newComposition.splice(0, newComposition.length)">Hapus Semua</button>
					<button class="btn btn-info ml-3" @click="saveComposition">Simpan Komposisi</button>
				</div>
			</div>
		</div>
		
		<div class="mt-5">
			<h3>Komposisi Warna Sebelumnya</h3>
			<hr>
			<div v-for="singleData in colorData">
				<h4>Form No. : {{singleData.form_code}} [{{singleData.form_dibuat}}]</h4>
				<table class="table">
					<thead>
						<tr>
							<th>Kode</th>
							<th>Nama</th>
							<th>Berat Terpakai (Gram)</th>
						</tr>
					</thead>
					<tbody >
						<tr v-for="color in singleData.data">
							<td>{{ color.paint_code }}</td>
							<td>{{ color.name }}</td>
							<td>{{ color.used_weight }}</td>
						</tr>
						<tr v-if="colorData.length == 0">
							<td>-</td>
							<td>-</td>
							<td>-</td>
						</tr>
						
					</tbody>
				</table>
				<hr>
			</div>
			<!-- {{colorData}} -->
		</div>
		
		
        
	</div>
</template>

<script>
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import env from '@/env'
import paintList from './children/paintList.vue'

export default {
	components : {
		Multiselect,
		paintList
	},
	data () {
		return {
			env,
            mobile : this.isMobile(),
			form_code: this.$route.params.id,
			woDetail: null,
			colorData : [],
			woProgress : null,

			newComposition : [
				
			],
			paintList : []
		}
	},
	async mounted() {
		this.getWoDetails()
		this.getWoProgress()
		this.getPaintList()
	},
	watch : {
		'newComposition' () {
			if (this.newComposition.length == 0) this.addNewComposition();
		}
	},
	computed : {
		buttonsShow () {
			if (this.newComposition.length == 1) {
				if (
					this.newComposition[0].paint_code == '' &&
					this.newComposition[0].name == '' &&
					this.newComposition[0].used_weight == 0
				) return false;
			}

			return true;
		}
	},
	methods: {
		getPaintList () {
			// /paint/list
			this.$http.get('/api/v1/masterData/customer_car/paint/list')
			.then((resp) => {
				this.paintList = resp.data.data
			})
			.catch((err) => {
				console.log(err)
			})
		},
		addNewComposition () {
			let user = this.$store.state.userData.userData
			// console.log(user)

			this.newComposition.push({
				paint_code : '',
				name : '',
				used_weight : 0,
				user_id : user.user_id,
				form_code : this.form_code
			})
		},
		getWoDetails(){
			this.$http.get(`/api/v1/workorder/${this.form_code}/detail`)
			.then(async (resp)=>{
                var data = resp.data.data;
                let carDetail = this.$store.getters.getModelDetailById(data.customer_car.car_id)

                this.woDetail = {
                    customer: data.customer,
                    car : data.customer_car,
                    work_order_id : this.form_code,
                    nomor_mesin : data.customer_car.engine_number,
                    nomor_rangka : data.customer_car.chassis_number,
                    nomor_polisi : data.customer_car.registration,
                    asuransi : data.customer_car.insurance,
                    kerusakan : this.evaluateDamage(data.condition.figure),
                    tanggal_masuk : moment(data.created_at).format('DD MMM YY HH:mm'),
                    pelanggan : data.customer.name,
                    cso : data.CSO,
                    merek : carDetail.brand_name,
                    tipe : carDetail.name,
                    image : data.condition.figureOverall.front.image ? data.condition.figureOverall.front.image : [''],
                    address : data.customer.address,
                    warna: data.customer_car.car_color.name,
                    tahun : data.customer_car.year,
                    car_id : data.customer_car.car.brand_id,
					car_name : data.customer_car.car.name,
					car_color : data.customer_car.car_color.name,
					price : data.customer_car.price
                }

				let user = this.$store.state.userData.userData

				this.newComposition.push({
					paint_code : '',
					name : '',
					used_weight : 0,
					user_id : user.user_id,
					form_code : this.form_code
				})
			})
			.then(()=>{
				this.getColorDetails();
			})
			.catch((err)=>{console.log(err)})
		},
		evaluateDamage(figure){
			var damages = ""
			for(var i in figure){
				for(var j in figure[i]){
					if(figure[i][j]) damages += `${this.toCapitalizedWords(j)}, `
				}
			}

			return damages ? damages.substring(0, damages.length-2) : '-'
		},
		getColorDetails () {
			this.$http.get(`/api/v1/masterData/customer_car/${this.woDetail.nomor_rangka}/car_paint`)
			.then((resp)=>{
				// this.colorData = resp.data.data;
				let data = resp.data.data;
				let newObj = []

				for(var i = 0 ; i < data.length ; i++) {
					let curData = data[i]
					let index = newObj.findIndex(x => x.form_code === curData.form_code)

					if(index == -1) {
						newObj.push({
							form_code : curData.form_code,
							form_dibuat : moment(curData.form_dibuat).format('MMM DD,Y'),
							data : [curData]
						})
					}
					else {
						newObj[index].data.push(curData)
					}
				}

				this.colorData = newObj
			})
			.catch((err)=>{
				console.log(err);
			})
		},
		getWoProgress() {
			this.$http.get(`/api/v1/workorder/steps/${this.form_code}`)
			.then((resp) => {
				console.log(resp.data.data)
				this.woProgress = resp.data.data.find(x => x.step_id == 1 && x.status == 0);
				// console.log(this.woProgress)

			})
			.catch((err) => {
				console.log(err)
			})
		},
		saveComposition () {
			let newCarPaint = {
				car_paints : []
			}

			for (var i in this.newComposition) {
				if (
					this.newComposition[i].paint_code == '' &&
					this.newComposition[i].name == '' &&
					this.newComposition[i].used_weight == 0
				) {

				} else {
					newCarPaint.car_paints.push(this.newComposition[i])
				}
			}

			// 
            //         
			this.$swal.fire({
				title: 'Konfirmasi penyelesaian perkerjaan!',
				icon: 'warning',
				showCancelButton: true
			}).then((result) => {
				if (result.value) {
					this.$http.post(`/api/v1/masterData/customer_car/${this.woDetail.nomor_rangka}/car_paint`, newCarPaint)
					.then((resp)=>{
						this.$store.dispatch('triggerAlert', [true, ['Warna telah berhasil di perbarui']])
						this.getColorDetails();

						//Clear new composition
						this.newComposition.splice(0, this.newComposition.length);
						console.log(this.woProgress)

						this.$http.patch(`/api/v1/workorder/steps/${this.woProgress.id}/done`, null)
						.then((resp) => {
							this.$swal.fire(
								'Berhasil!',
								`Warna Telah Berhasil Tersimpan Pada System`,
								'success'
							)

							// this.getWoProgress();
							this.$router.push('/work-order-listing')
						})
						.catch((err) => {
							console.log(err)
						})
						
					})
					.catch((err)=>{
						console.log(err);
						this.$store.dispatch('triggerAlert' , [false , err.response.data.data])
					})
					
				}
			})
			
		},
	}
}
</script>

<style scoped>
  .wo-stats th {
    font-size:16px;
  }
  .wo-stats td {
    padding-left:10px;
  }

  .wo-listing-box {
    margin-top: 20px;
    border:1px solid #4f4f4f;
    border-radius:5px;
  }
  .wo-listing-box .listing-stats{
    font-size: 16px;
    margin: 0;
  }
  .wo-listing-box th {
    font-size:16px;
    padding-right:10px;
  }
  
  .clickAble:hover{
    cursor: pointer;
  }
  .vert-aligned {
    vertical-align: middle;
	}

	td {
		vertical-align: middle;
	}

	.redStatus {
		background-color : #FB9072;
	}
</style>